<template>
  <div
    id=time-container
    @click="onEditClick"
    @mouseover="hovered = true"
    @mouseout="hovered = false"
  >
    <span class="ur-container">
      <Ur
        :fillColor="'#ffffff'"
        :strokeColor="'#0F1C70'"
      />
    </span>
    <span class="time">{{timeText}}</span>
    <edit-button
      v-if="editable"
      :onClick="onEditClick"
      :class="{'parent-hover': hovered}"
      style="margin-left: auto;"
    />
  </div>
</template>

<script>
import Ur from '@/components/Icons/Ur';
import { format } from 'date-fns';
import da from 'date-fns/locale/da';
import EditButton from './EditButton.vue';
export default {
  name: 'time-container',
  components: { EditButton, Ur },
  props: {
    startTime: String,
    onEditClick: { type: Function, default: () => {} },
    editable: { type: Boolean, default: true },
  },
  data: function() {
    return {
      hovered: false,
    };
  },
  computed: {
    timeText() {
      if (!this.startTime) {
        return '';
      }
      return `Afgang d. ${format(this.startTime, 'Do MMMM', {
        locale: da,
      })} kl. ${format(this.startTime, 'HH:mm', { locale: da })}`;
    },
  },
};
</script>

<style lang="scss" scoped>
#time-container {
  background: #ffffff;
  box-shadow: 0 0 15px 0 rgba(15, 28, 112, 0.1);
  border-radius: 6px;
  height: 76px;
  margin: 22px 60px 22px 80px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  padding: 0 18px 0 40px;
  font-weight: 600;
  position: relative;
  cursor: pointer;
  .time {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.ur-container {
  position: absolute;
  top: 50%;
  margin-top: -17px;
  left: -56px;
}

@media only screen and (max-width: $mobile-max-width) {
  #time-container {
    margin: 20px 30px 20px 60px;
    padding: 0 10px 0 20px;
    height: 70px;
  }

  .ur-container {
    left: -46px;
  }
}
</style>
